import { Component } from '@angular/core';
import { DiscussionPageBaseComponent } from '../../shared/discussion-page-base/discussion-page-base.component';

@Component({
  selector: 'app-discussion-public',
  standalone: true,
  imports: [DiscussionPageBaseComponent],
  template: `
    <app-discussion-page-base
      pageTitle="Public"
      pageDescription="Explore public discussions open to all community members. Share ideas, ask questions, and engage with the broader community."
      activeTab="public"
      categoryType="PUBLIC"
    ></app-discussion-page-base>
  `,
})
export class DiscussionPublicComponent {}
